/**
 * Generated from BoardCardsLayout.fla
 */
export function BoardCardsLayout(this: IBoardCardsLayout) {
	const main = this.main;
	BoardCardsLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function BoardCardsLayout_main(this: IBoardCardsLayout_main) {
	const board = this.board;
	BoardCardsLayout_board.call(this.board);
	board.x = 0;
	board.y = 0;
	if (board.onLayout) board.onLayout();
	return this;
}
function BoardCardsLayout_board(this: IBoardCardsLayout_board) {
	const cards = this.cards;
	if (!cards[0] && cards.elementFactory) {
		cards[0] = cards.elementFactory(0,undefined);
	}
	if (cards[0]) {
		BoardCardsLayout_cards0.call(cards[0] as IBoardCardsLayout_cards0);
		cards[0].x = -417.65;
		cards[0].y = -588.65;
		cards[0].width = 259.20;
		cards[0].height = 325.80;
		if (cards[0].onLayout) cards[0].onLayout();
	}
	if (!cards[1] && cards.elementFactory) {
		cards[1] = cards.elementFactory(1,undefined);
	}
	if (cards[1]) {
		BoardCardsLayout_cards0.call(cards[1] as IBoardCardsLayout_cards0);
		cards[1].x = -137.7;
		cards[1].y = -588.65;
		cards[1].width = 259.20;
		cards[1].height = 325.80;
		if (cards[1].onLayout) cards[1].onLayout();
	}
	if (!cards[2] && cards.elementFactory) {
		cards[2] = cards.elementFactory(2,undefined);
	}
	if (cards[2]) {
		BoardCardsLayout_cards0.call(cards[2] as IBoardCardsLayout_cards0);
		cards[2].x = 142.25;
		cards[2].y = -588.65;
		cards[2].width = 259.20;
		cards[2].height = 325.80;
		if (cards[2].onLayout) cards[2].onLayout();
	}
	if (!cards[3] && cards.elementFactory) {
		cards[3] = cards.elementFactory(3,undefined);
	}
	if (cards[3]) {
		BoardCardsLayout_cards0.call(cards[3] as IBoardCardsLayout_cards0);
		cards[3].x = 422.25;
		cards[3].y = -588.65;
		cards[3].width = 259.20;
		cards[3].height = 325.80;
		if (cards[3].onLayout) cards[3].onLayout();
	}
	if (!cards[4] && cards.elementFactory) {
		cards[4] = cards.elementFactory(4,undefined);
	}
	if (cards[4]) {
		BoardCardsLayout_cards0.call(cards[4] as IBoardCardsLayout_cards0);
		cards[4].x = 699;
		cards[4].y = -327.45;
		cards[4].width = 259.20;
		cards[4].height = 325.80;
		if (cards[4].onLayout) cards[4].onLayout();
	}
	if (!cards[5] && cards.elementFactory) {
		cards[5] = cards.elementFactory(5,undefined);
	}
	if (cards[5]) {
		BoardCardsLayout_cards0.call(cards[5] as IBoardCardsLayout_cards0);
		cards[5].x = 699;
		cards[5].y = 12.25;
		cards[5].width = 259.20;
		cards[5].height = 325.80;
		if (cards[5].onLayout) cards[5].onLayout();
	}
	if (!cards[6] && cards.elementFactory) {
		cards[6] = cards.elementFactory(6,undefined);
	}
	if (cards[6]) {
		BoardCardsLayout_cards0.call(cards[6] as IBoardCardsLayout_cards0);
		cards[6].x = 699;
		cards[6].y = 351.95;
		cards[6].width = 259.20;
		cards[6].height = 325.80;
		if (cards[6].onLayout) cards[6].onLayout();
	}
	if (!cards[7] && cards.elementFactory) {
		cards[7] = cards.elementFactory(7,undefined);
	}
	if (cards[7]) {
		BoardCardsLayout_cards0.call(cards[7] as IBoardCardsLayout_cards0);
		cards[7].x = 422.25;
		cards[7].y = 595.75;
		cards[7].width = 259.20;
		cards[7].height = 325.80;
		if (cards[7].onLayout) cards[7].onLayout();
	}
	if (!cards[8] && cards.elementFactory) {
		cards[8] = cards.elementFactory(8,undefined);
	}
	if (cards[8]) {
		BoardCardsLayout_cards0.call(cards[8] as IBoardCardsLayout_cards0);
		cards[8].x = 142.25;
		cards[8].y = 595.75;
		cards[8].width = 259.20;
		cards[8].height = 325.80;
		if (cards[8].onLayout) cards[8].onLayout();
	}
	if (!cards[9] && cards.elementFactory) {
		cards[9] = cards.elementFactory(9,undefined);
	}
	if (cards[9]) {
		BoardCardsLayout_cards0.call(cards[9] as IBoardCardsLayout_cards0);
		cards[9].x = -137.7;
		cards[9].y = 595.75;
		cards[9].width = 259.20;
		cards[9].height = 325.80;
		if (cards[9].onLayout) cards[9].onLayout();
	}
	if (!cards[10] && cards.elementFactory) {
		cards[10] = cards.elementFactory(10,undefined);
	}
	if (cards[10]) {
		BoardCardsLayout_cards0.call(cards[10] as IBoardCardsLayout_cards0);
		cards[10].x = -417.65;
		cards[10].y = 595.75;
		cards[10].width = 259.20;
		cards[10].height = 325.80;
		if (cards[10].onLayout) cards[10].onLayout();
	}
	if (!cards[11] && cards.elementFactory) {
		cards[11] = cards.elementFactory(11,undefined);
	}
	if (cards[11]) {
		BoardCardsLayout_cards0.call(cards[11] as IBoardCardsLayout_cards0);
		cards[11].x = -695.95;
		cards[11].y = 351.95;
		cards[11].width = 259.20;
		cards[11].height = 325.80;
		if (cards[11].onLayout) cards[11].onLayout();
	}
	if (!cards[12] && cards.elementFactory) {
		cards[12] = cards.elementFactory(12,undefined);
	}
	if (cards[12]) {
		BoardCardsLayout_cards0.call(cards[12] as IBoardCardsLayout_cards0);
		cards[12].x = -695.95;
		cards[12].y = 12.25;
		cards[12].width = 259.20;
		cards[12].height = 325.80;
		if (cards[12].onLayout) cards[12].onLayout();
	}
	if (!cards[13] && cards.elementFactory) {
		cards[13] = cards.elementFactory(13,undefined);
	}
	if (cards[13]) {
		BoardCardsLayout_cards0.call(cards[13] as IBoardCardsLayout_cards0);
		cards[13].x = -695.95;
		cards[13].y = -327.45;
		cards[13].width = 259.20;
		cards[13].height = 325.80;
		if (cards[13].onLayout) cards[13].onLayout();
	}
	return this;
}
function BoardCardsLayout_cards0(this: IBoardCardsLayout_cards0) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-free-play-back.png", 0.502, 0.500);
	return this;
}
interface IBoardCardsLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IBoardCardsLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IBoardCardsLayoutSprite extends IBoardCardsLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IBoardCardsLayoutText extends IBoardCardsLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IBoardCardsLayoutPolygon extends Array<number> {
}
interface IBoardCardsLayout {
	readonly main: IBoardCardsLayout_main;
}
interface IBoardCardsLayout_main extends IBoardCardsLayoutContainer {
	readonly board: IBoardCardsLayout_board;
}
interface IBoardCardsLayout_board extends IBoardCardsLayoutContainer {
	readonly cards: IBoardCardsLayoutArray<IBoardCardsLayout_cards0>;
}
interface IBoardCardsLayout_cards0 extends IBoardCardsLayoutSprite {
}
